import {Component, OnInit, OnDestroy, ViewChild, Input} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {LinkedAccountFilter} from "./linkedAccount.filter";
import { debounceTime } from 'rxjs/operators';
import {LookupService} from "../srvs/lookup";

@Component({
  selector: 'micro-linkedAccounts',
  templateUrl: './linkedAccounts.component.html'
})
export class LinkedAccountsComponent implements OnInit, OnDestroy  {

  @Input()
  userId:any;

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:LinkedAccountFilter = new LinkedAccountFilter();
  lookups:any;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private auth:AuthService,
              private env:EnvService,
              private http:HttpClient,
              private lookupService:LookupService) {
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
  }

  ngOnInit() {
    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    console.log("reload linked accounts for " + this.userId)
    if (!this.userId || this.userId === '') {
      return;
    }

    let params:HttpParams = this.filter.getParams()
        .set("userId", this.userId)
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || 20))
      ;

    this.http.get(`${this.env.e.url}/auth/linkedAccounts`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }

  syncLinkedAccount() {
    this.http.get(`${this.env.e.url}/task/taskCarriers/${this.filter.carrierId}/sync/${this.userId}`).subscribe(
      data => {
        this.reload();
      }
    );
  }

  unLinkedAccount(linkId) {
    this.http.delete(`${this.env.e.url}/auth/linkedAccounts/${linkId}`).subscribe(
      data => {
        this.reload();
      }
    );

  }
}
